/**
 * Route definition for /faq
 * Renders the FaqContainer (Frequently Asked Questions) component.
 *
 * @module routes/faq
 * @category Routes
 */
import { createFileRoute } from '@tanstack/react-router'
import FaqContainer from "@/containers/FrequentlyAsked";

export const Route = createFileRoute('/$locale/faq')({
  component: FAQ,
})

/**
 * FAQ page component.
 * Renders the FrequentlyAsked container to display frequently asked questions.
 *
 * @returns {React.ReactElement}
 */
function FAQ() {

    return (
        <>
            <FaqContainer/>
        </>
    );
}